export default "__VITE_ASSET__RloE05ss__"